export default {"src":"/_next/static/media/0xd6070ae98b8069de6b494332d1a1a81b6179d960.36546af4.svg","height":699,"width":699,"blurWidth":0,"blurHeight":0};